import { integrationsPropertiesChange } from 'client/modules/Settings/SettingsActions';
import querystring from 'query-string';
import { createActions } from 'redux-actions';

import callApi from '../../util/apiCaller';

export const { getCb, addCb, removeCb, resetState } = createActions(
  {},
  'GET_CB',
  'ADD_CB',
  'REMOVE_CB',
  'RESET_STATE',
);

export const { checkVersionCb, upgradePackageCb } = createActions(
  {},
  'CHECK_VERSION_CB',
  'UPGRADE_PACKAGE_CB',
);

export const getIntegration = (token, type, fields) => dispatch =>
  callApi(dispatch, `integrations/${type}?${querystring.stringify(fields)}`, token).then(res => {
    dispatch(getCb(res));
    return res;
  });

export const removeIntegration = (token, type) => dispatch =>
  callApi(dispatch, `integrations/${type}`, token, 'delete').then(() => dispatch(removeCb()));

export const addIntegration = (token, code, state, type) => dispatch => {
  dispatch(resetState());
  callApi(dispatch, `integrations/${type}`, token, 'post', { code, state })
    .then(res => {
      dispatch(
        addCb({
          type: 'success',
          message: null,
          integrationType: type,
          state,
          integrationProps: res,
        }),
      );
      dispatch(integrationsPropertiesChange({ type, props: res }));
    })
    .catch(err => {
      dispatch(addCb({ type: 'error', message: err.response.message }));
    });
};

export const checkSalesforcePackageStatus = token => dispatch =>
  callApi(dispatch, 'integrations/salesforce/version', token).then(res => {
    dispatch(checkVersionCb(res));
    return res;
  });

export const upgradeSalesforcePackage = token => dispatch =>
  callApi(dispatch, 'integrations/salesforce/upgrade', token, 'post', {}).then(res => {
    return res;
  });

export const installSalesforcePackage = token => dispatch =>
  callApi(dispatch, 'integrations/salesforce/install', token, 'post', {}).then(res => {
    return res;
  });

export const checkSalesforceInstallationStatus = (token, installRequestId) => dispatch =>
  callApi(dispatch, `integrations/salesforce/install-status/${installRequestId}`, token).then(
    res => {
      return res;
    },
  );

export const getSlackChannels =
  (token, search = '') =>
  dispatch => {
    const url = search
      ? `integrations/slack/channels?search=${encodeURIComponent(search)}`
      : 'integrations/slack/channels';
    return callApi(dispatch, url, token).then(res => {
      return res;
    });
  };

export const refreshSlackChannels = token => dispatch => {
  return callApi(dispatch, 'integrations/slack/channels/refresh', token, 'POST').then(res => {
    return res;
  });
};

export const getSlackChannelSyncInfo = token => dispatch => {
  return callApi(dispatch, 'integrations/slack/channels/sync-info', token).then(res => {
    return res;
  });
};
